<template>
    <div>
        <div v-if="isMobile" style="padding: 10px">

            <div class="" v-show="isLoading">
                <ul>
                    <a-row :gutter="{ xs: 8, sm: 8, md: 16, lg: 16 }">
                        <li v-for="item in 6 " :key="item">
                            <a-col :xs="12" :sm="12" :md="8" :lg="6" :xl="4">
                                <spin class="spin"/>
                            </a-col>
                        </li>
                    </a-row>
                </ul>
            </div>

            <div v-show="!isLoading">
                <a-row :gutter="{ xs: 8, sm: 8, md: 16, lg: 16 }">
                    <div style="font-size: 18px;text-align: center;margin: 50px" v-if="isEmpty">暂无相关搜索结果，换个关键词试试吧 : )
                    </div>
                    <ul v-else>
                        <li v-for="item in list " :key="item.articleId">
                            <a-col :xs="12" :sm="12" :md="8" :lg="6" :xl="4" class="col">
                                <article-list-item :article-info="item"/>
                            </a-col>
                        </li>
                    </ul>
                </a-row>

                <div class="bottomPage" style="clear: both">
                    <a-pagination @change="onChange" :current=pageNum :defaultPageSize=pageSize
                                  :total='total'/>
                </div>
            </div>
        </div>

        <div v-else class="search-course">
            <div class="route">
                <a-breadcrumb>
                    <a-breadcrumb-item href="">
                        <span></span>
                        <router-link to="/">
                            <a-icon type="home"/>
                            首页
                        </router-link>
                    </a-breadcrumb-item>
                    <a-breadcrumb-item href="">
                        <span>文章</span>
                    </a-breadcrumb-item>
                </a-breadcrumb>
            </div>


            <div class="classList" v-show="isLoading">
                <dl>
                    <dt v-for="item in 5" :key="item">
                        <spin class="spin"/>
                    </dt>
                </dl>
            </div>
            <div class="classList" v-show="!isLoading">
                <div v-if="isEmpty" style="font-size: 20px;text-align: center;margin: 50px">
                    暂无相关搜索结果，换个关键词试试吧 : )
                </div>

                <ul v-else>
                    <li v-for="item in list" :key="item.articleId">
                        <article-list-item :article-info="item"/>
                    </li>
                </ul>

                <div class="bottomPage" style="clear: both">
                    <a-pagination @change="onChange" :current=pageNum :defaultPageSize=pageSize :total='total'/>
                </div>
            </div>

        </div>

    </div>
</template>

<script>
    import spin from "@components/loading/Spin"
    import common from "../../mixin/common";
    import {listArticle} from "@api/article";
    import {SUCCESS} from "@constants/code";
    import {showError} from "@utils/msg";
    import ArticleListItem from "@components/article/ArticleListItem";


    export default {
        name: "searchClass",
        mixins: [common],
        components: {
            ArticleListItem,
            spin,
        },
        data() {
            return {
                title: "",
                list: [],
                //当前页数
                pageNum: 1,
                //每页容量
                pageSize: 10,
                //    总数
                total: 0,
                isLoading: false
            }
        },
        created() {
            this.onSearch();
        },
        methods: {
            //    翻页
            onChange(current) {
                this.pageNum = current;
                this.onSearch();
            },
            onSearch() {
                this.isLoading = true;
                listArticle({
                    title: this.title,
                }, this.pageNum, this.pageSize).then((res) => {
                    if (res.code === SUCCESS) {
                        this.total = res.total;
                        this.list = res.rows;
                    } else {
                        showError("获取列表错误", res.msg);
                    }
                    this.isLoading = false;
                }).catch((err) => {
                    console.error(err)
                });
            },
        },
        computed: {
            isEmpty() {
                return !this.list || this.list.length === 0
            },
        },
        watch: {},
    }
</script>

<style scoped lang="less">

    @import "../../styles/course.less";
    /*搜索框*/
    /deep/ .ant-input-group-wrapper {
        width: 100%;
        /*max-width: 400px;*/
        margin: 0 auto;
        /*height: 24px;*/
    }

    .search-bar-input {
        /deep/ .ant-input-lg {
            height: 30px;
            font-size: 14px;
        }
    }

    /deep/ .search-bar-button {
        height: 30px;
        font-size: 14px;
        text-align: center;
        text-indent: -4px;
    }

    .subject-list {
        width: 1200px;
        margin: 2px auto;
        padding: 10px 20px;
        background: #F4F4F4;
        line-height: 30px;

        .subject-list-box {
            margin-left: 50px;
        }
    }

    .condition-list {
        padding: 10px;
        background: #F4F4F4;

        h3 {
            float: left;
            line-height: 30px;
            color: rgba(0, 0, 0, 0.5);
        }

        span {
            display: inline-block;
            min-width: 70px;
            height: 30px;
            line-height: 30px;
            text-align: center;
            margin: 0 6px;
            padding: 0 5px;

        }

        span:hover {
            cursor: pointer;
        }

        .active {
            color: white;
            background: #00CF8C;
        }
    }

    .course-type {
    }

    .bottomPage {
        text-align: center;
        margin-bottom: 20px;
    }

    .search-course {
        min-height: calc(100vh - 270px);
        width: 1200px;
        margin: 0 auto;
    }

    .route {
        width: 1200px;
        margin: auto;
        padding: 20px 0 20px 10px;
        font-size: 16px;
    }

    /deep/ .ant-breadcrumb-link {
        font-size: 16px;
    }

    .classList {
        width: 1200px;
        overflow: hidden;
        margin: auto;

        dl dt {
            float: left;
            width: 20%;
            position: relative;
            border-radius: 3px;
            overflow: hidden;
            padding: 7px 7px 10px;
            margin-bottom: 20px;
            cursor: pointer;
        }
    }

</style>
